import Vue from 'vue';

Vue.config.ignoredElements = [
  's2vg',
  // Use a `RegExp` to ignore all elements that start with "ion-"
  // 2.5+ only
  /^ion-/,
];
